import { skipToken } from '@reduxjs/toolkit/query';
import { useGetVehicleId } from 'pages/CreateVehicle/hooks/useGetVehicleId';
import { useGetSectionsQuery } from 'services/api/vehicle-sections';

export const useExteriorVideo = () => {
  const vehicleId = useGetVehicleId();
  const { data: sections } = useGetSectionsQuery(vehicleId || skipToken);

  return sections?.exterior?.subsections?.exterior?.video;
};
